import {
  FormPrimitiveValuesArray,
  FormPrimitiveValuesObject,
} from '../typings';

export const isFormPrimitiveValuesObjectArray = (
  arr: FormPrimitiveValuesArray | FormPrimitiveValuesObject[],
): arr is FormPrimitiveValuesObject[] => {
  return arr.some(item => typeof item === 'object' && item !== null);
};
